import { store } from '@/common/root';
import {
  TARGET_STATES,
  ISCSI_TYPE
} from '@/common/constants/iscsiTarget.constants';

function targetState(target) {
  if (target.tasks && target.tasks.length && TARGET_STATES.loading) {
    return TARGET_STATES.loading;
  }
  return TARGET_STATES[target.state] || TARGET_STATES.unknown || target.state;
}

export default function targetMapper(targetGroup) {
  if (!Array.isArray(targetGroup?.targets)) {
    return [];
  }

  return targetGroup.targets.map((target) => {
    const isIscsi = targetGroup.type === ISCSI_TYPE;
    let id = targetGroup.type === ISCSI_TYPE ? target.iqn : target.wwn;
    const node = store.getters['nodes/getItemById'](target.node_id);
    const state = targetState(target);

    if (!id || typeof id !== 'string') {
      id = '';
    }

    return {
      ...target,
      id,
      name: isIscsi && id ? id.substr(id.lastIndexOf(':') + 1) : id,
      type: targetGroup.type,
      targetGroup,
      targetGroupId: targetGroup.id,
      targetGroupName: targetGroup.name,
      isDeletable: !!id,
      node,
      nodeName: node?.name || target.node_id,
      statusIcon: state.icon,
      statusText: state.text,
      interfaces: target.portals?.map((iface) => iface.ipaddr).join(', ')
    };
  });
}
